import {
  Form,
  SubmitButton,
  Text,
  TextAreaInputField,
  TextInputField,
} from '@/components';
import { useForm } from '@/hooks';
import { zodResolver } from '@hookform/resolvers/zod';
import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import type { z } from 'zod';
import { CabinetDecisionWithDefinedIndicatorsModel } from '../../../_models/project';

type FormValues = z.infer<typeof CabinetDecisionWithDefinedIndicatorsModel>;

interface Props {
  initialValues?: Partial<FormValues>;
  onSubmit: (values: FormValues) => void;
}

export const CabinetDecisionsForm: FC<Props> = ({
  initialValues,
  onSubmit,
}) => {
  const { t } = useTranslation();
  const {
    handleSubmit,
    control,
    formState: { errors, isSubmitting, isDirty, isSubmitSuccessful },
  } = useForm<FormValues>({
    defaultValues: initialValues,
    resolver: zodResolver(CabinetDecisionWithDefinedIndicatorsModel),
  });

  return (
    <Form
      leavePageAlertCondition={{
        isDirty,
        isSubmitting,
        isSubmitSuccessful,
      }}
      layout="vertical"
      onFinish={handleSubmit(onSubmit)}
    >
      <Text
        variant="h5"
        text={t('cabinet-decisions-where-related-indicators-are-defined')}
      />
      <TextInputField
        name="name"
        autocompleteKey="cabinetDecision.name"
        label={t('name')}
        control={control}
        errors={errors}
      />
      <TextInputField
        name="url"
        label={t('url')}
        control={control}
        errors={errors}
        fallbackValue={null}
      />
      <TextAreaInputField
        name="relevantPart"
        label={t('relevant-part')}
        control={control}
        errors={errors}
      />

      <SubmitButton loading={isSubmitting} disabled={!isDirty} />
    </Form>
  );
};
